import { Card, Col, Row } from "antd";
import "./status.css";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DownloadOutlined,
  FileDoneOutlined,
  PullRequestOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";

const SummaryByStatus = ({
  waiting_inbound = 0,
  waiting_outbound = 0,
  approve = 0,
  done = 0,
  reject = 0,
  total = 0,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParam = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (value !== null) {
      newSearchParams.set(key, value);
    } else {
      newSearchParams.delete(key);
    }
    setSearchParams(newSearchParams);
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        {waiting_inbound === null ? null : (
          <Col lg={5} md={5} sm={8} xs={24}>
            <div
              className={`container ${
                searchParams.get("status") === "pending" ? "active" : ""
              }`}
              onClick={() => updateSearchParam("status", "pending")}
            >
              <div className="circle" style={{ backgroundColor: "#fffbe7" }}>
                <DownloadOutlined
                  className="icon"
                  style={{ color: "#faad14" }}
                />
              </div>
              <div className="text">
                <h2 className="title">{waiting_inbound}</h2>
                <p className="content">Menunggu Inbound</p>
              </div>
            </div>
          </Col>
        )}
        {waiting_outbound === null ? null : (
          <Col lg={5} md={5} sm={8} xs={24}>
            <div
              className={`container ${
                searchParams.get("status") === "pending" ? "active" : ""
              }`}
              onClick={() => updateSearchParam("status", "pending")}
            >
              <div className="circle" style={{ backgroundColor: "#fffbe7" }}>
                <UploadOutlined className="icon" style={{ color: "#faad14" }} />
              </div>
              <div className="text">
                <h2 className="title">{waiting_outbound}</h2>
                <p className="content">Menunggu Outbound</p>
              </div>
            </div>
          </Col>
        )}
        <Col lg={5} md={5} sm={8} xs={24}>
          <div
            className={`container ${
              searchParams.get("status") === "approve" ? "active" : ""
            }`}
            onClick={() => updateSearchParam("status", "approve")}
          >
            <div className="circle" style={{ backgroundColor: "#f6ffee" }}>
              <CheckCircleOutlined
                className="icon"
                style={{ color: "#52c41a" }}
              />
            </div>
            <div className="text">
              <h2 className="title">{approve}</h2>
              <p className="content">Total Disetujui</p>
            </div>
          </div>
        </Col>
        <Col lg={4} md={4} sm={8} xs={24}>
          <div
            className={`container ${
              searchParams.get("status") === "done" ? "active" : ""
            }`}
            onClick={() => updateSearchParam("status", "done")}
          >
            <div className="circle" style={{ backgroundColor: "#f6ffee" }}>
              <FileDoneOutlined className="icon" style={{ color: "#52c41a" }} />
            </div>
            <div className="text">
              <h2 className="title">{done}</h2>
              <p className="content">Total Selesai</p>
            </div>
          </div>
        </Col>
        <Col lg={5} md={5} sm={8} xs={24}>
          <div
            className={`container ${
              searchParams.get("status") === "reject" ? "active" : ""
            }`}
            onClick={() => updateSearchParam("status", "reject")}
          >
            <div className="circle" style={{ backgroundColor: "#fff2f0" }}>
              <CloseCircleOutlined
                className="icon"
                style={{ color: "#ff4d4f" }}
              />
            </div>
            <div className="text">
              <h2 className="title">{reject}</h2>
              <p className="content">Total Penolakan</p>
            </div>
          </div>
        </Col>
        <Col lg={5} md={5} sm={8} xs={24}>
          <div
            className="container"
            onClick={() => updateSearchParam("status", "")}
          >
            <div className="circle" style={{ backgroundColor: "#effafe" }}>
              <PullRequestOutlined
                className="icon"
                style={{ color: "#43b7ff" }}
              />
            </div>
            <div className="text">
              <h2 className="title">{total}</h2>
              <p className="content">Total Permintaan</p>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SummaryByStatus;
